/**
 * Storage keys shared between the redux-persist layer and the auth storage cleanup.
 *
 * Kept in a module with no redux imports so `util/localStorageUtils` (on the Keycloak boot
 * path) can name the entries it must preserve without pulling redux-persist in.
 */
export const CASE_LIST_PERSIST_KEY = 'cmCaseList';

/** The sessionStorage key redux-persist writes for the slice (its KEY_PREFIX + key). */
export const CASE_LIST_PERSIST_STORAGE_KEY = `persist:${CASE_LIST_PERSIST_KEY}`;
